import React from 'react';

import DashboardLayout from 'layouts/Protected/DashboardLayout/DashboardLayout';

const Dashboard = () => {
  return <DashboardLayout />;
};

export default Dashboard;
